import {
  DataGridPro,
  GridCallbackDetails,
  GridColDef,
  GridColumnVisibilityModel,
  GridEvents,
  GridFilterModel,
  GridSelectionModel,
  GridToolbar,
  GRID_CHECKBOX_SELECTION_COL_DEF,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import styled from "styled-components";
import {
  setOPenOrdersModal,
  setOPenOrdersTransactionModal,
} from "../../store/actions/layoutActions";
import { Tooltip } from "@mui/material";
import { ButtonsContainer, StyledBtn } from "./Styles";
import { exportOrdersTable } from "../../utils/ExcelExport";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { filterArrayWithSearch } from "../../utils/FilterArray";
import Header from "./Header";
import { fetchOrders } from "../../services/DatabaseService";
import ProgressBar from "@badrap/bar-of-progress";

function mapStateToProps(state: any) {
  return {
    ordersList: state.data.ordersList,
    currentUser: state.auth.loggedInUser,
    userFilterItems: state.data.userFilterItems,
    orderEventTransactions: state.data.orderEventTransactions,
    devices: state.data.devices,
  };
}
const CompletedOrders = ({
  ordersCols,
  filterModelChanged,
  userFilterItems,
  ordersList,
  currentUser,
  orderEventTransactions,
  devices,
}: any) => {
  const apiRef = useGridApiRef();
  // progresbar instance
  const progress = new ProgressBar({
    size: 4,
    color: "whitesmoke",
    className: "z-50",
    delay: 100,
  });
  // states
  const [cols, setCols] = useState(ordersCols);
  const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);
  const [completedOrders, setCompletedOrders] = useState([] as any);
  const [searchValue, setSearchValue] = useState("");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [colsVisibilityModel, setColsVisibilityModel] = useState({
    currentLocation: false,
    weekNumber: false,
    customer: false,
    readyForPickup: false,
    orderStatus: false,
  } as GridColumnVisibilityModel);
  const selectionRange = [
    {
      startDate: fromDate,
      endDate: toDate,
      key: "selection",
    },
  ];
  // hoooks
  // useEffect(() => {
  //   let searchedOrderslist = filterArrayWithSearch(ordersList, searchValue);
  //   setCompletedOrders(
  //     searchedOrderslist?.filter((order: any) => order.status !== "complete")
  //   );
  // }, [ordersList, searchValue]);

  useEffect(() => {
    if (ordersList.length === 0) {
      fetchOrders(currentUser, devices, orderEventTransactions).then(
        (orders) => {
          let searchedOrderslist = filterArrayWithSearch(orders, searchValue);
          setCompletedOrders(
            searchedOrderslist?.filter(
              (order: any) => order.status === "complete"
            )
          );
          setLoading(false);
        }
      );
    } else {
      let searchedOrderslist = filterArrayWithSearch(ordersList, searchValue);
      setCompletedOrders(
        searchedOrderslist?.filter((order: any) => order.status === "complete")
      );
      setLoading(false);
    }
  }, [ordersList, searchValue]);
  // getting cols model from localstorage
  useEffect(() => {
    if (localStorage.getItem("completedOrdersCols")) {
      setColsVisibilityModel(
        JSON.parse(localStorage.getItem("completedOrdersCols"))
      );
    }
  }, []);
  //   // event listener column order on dragend hook
  useEffect(() => {
    const unsbsc = () =>
      apiRef.current?.subscribeEvent(
        GridEvents.columnHeaderDragEnd,
        (params) => {
          localStorage.setItem(
            "completedOrdersColsOrder",
            JSON.stringify(apiRef.current.state.columns.all)
          );
        }
      );
    return unsbsc();
  }, [apiRef]);
  // getting columns orders from localstorage
  useEffect(() => {
    if (localStorage.getItem("completedOrdersColsOrder")) {
      let colsOrder = JSON.parse(
        localStorage.getItem("completedOrdersColsOrder")
      );
      const tempCols: GridColDef[] = colsOrder
        .filter((c) => c !== "__check__")
        .map((col) => cols.find((c) => c.field == col));
      setCols(tempCols);
    }
  }, []);
  // ±functions
  // open tags modal
  const showAssetsList = (row: any) => {
    // !todo:open modal
    setOPenOrdersModal(true, row.id);
  };
  //open transactionmodal
  const openTransactionModal = (params: any) => {
    if (params.field === "orderId" || params.field === "orderReference") {
      return setOPenOrdersTransactionModal(true, params.id);
    }
  };
  // exportSelected
  const exportSelected = () => {
    exportOrdersTable(selectionModel);
  };
  // searchHandelar
  const searchHandelar = (e) => {
    setSearchValue(e.target.value);
  };
  //
  // handleSelect
  const getOrdersFromRange = async () => {
    progress.start();
    setLoading(true);
    // setShowRangePicker(false);
    await fetchOrders(
      currentUser,
      devices,
      orderEventTransactions,
      fromDate,
      toDate,
      true
    );
    setLoading(false);
    progress.finish();
  };
  //fn handleSelect
  const handleSelect = (ranges: any) => {
    setFromDate(ranges.selection.startDate);
    setToDate(ranges.selection.endDate);
  };
  //   columnVisibilityModelChanged(
  const columnVisibilityModelChanged = (model: GridColumnVisibilityModel) => {
    setColsVisibilityModel(model);
    localStorage.setItem("completedOrdersCols", JSON.stringify(model));
  };
  return (
    <Container>
      <Header
        rangePickerTitle="Orders"
        currentUser={currentUser}
        orderEventTransactions={orderEventTransactions}
        devices={devices}
        inputChanged={searchHandelar}
        searchValue={searchValue}
        getOrdersFromRangeClicked={getOrdersFromRange}
        handleSelect={handleSelect}
        selectionRange={selectionRange}
        btnsDisabled={!selectionModel.length && true}
        hideRangePicker={false}
      />
      <StyledDataGrid
        apiRef={apiRef}
        columnVisibilityModel={colsVisibilityModel}
        onColumnVisibilityModelChange={(model: GridColumnVisibilityModel) =>
          columnVisibilityModelChanged(model)
        }
        getRowId={(row) => row.orderId}
        checkboxSelection
        onSelectionModelChange={(newSelectionModel) => {
          setSelectionModel(newSelectionModel);
        }}
        selectionModel={selectionModel}
        loading={loading}
        disableSelectionOnClick
        rows={completedOrders}
        columns={cols}
        pageSize={100}
        components={{ Toolbar: GridToolbar }}
        onCellClick={(params) => openTransactionModal(params)}
        onRowDoubleClick={(row: any) => showAssetsList(row)}
        onFilterModelChange={(
          model: GridFilterModel,
          details: GridCallbackDetails
        ) => filterModelChanged(model, details, "completedOrders")}
        initialState={{
          filter: {
            filterModel: {
              items: userFilterItems?.filter(
                (items) => items.table === "completedOrders"
              ),
            },
          },
          // pinnedColumns: {
          //   left: [
          //     GRID_CHECKBOX_SELECTION_COL_DEF.field,
          //     "scanTimeStampDate",
          //     "orderId",
          //   ],
          //   right: ["orderStatus"],
          // },
        }}
      />
    </Container>
  );
};

export default connect(mapStateToProps)(CompletedOrders);
const Container = styled.div`
  width: 100%;
  height: 80vh;
`;

const StyledDataGrid = styled(DataGridPro)`
  height: 100% !important;
`;
